import { ComponentType } from "react";

import InitialWeightPredictScreen from "@/components/AIWeightPredict/InitialWeightPredictScreen";
import BmiScreenFemale from "@/components/BmiScreen/BmiScreenFemale";
import BmiScreenMale from "@/components/BmiScreen/BmiScreenMale";
import AIBodyScanPromo from "@/components/Promo/AIBodyScanPromo";
import CalisthenicsFeedbackLoops from "@/components/Promo/CalisthenicsFeedbackLoops";
import CortisolScreen from "@/components/Promo/CortisolScreen";
import CyclePhase from "@/components/Promo/CyclePhase";
import PromoHelp from "@/components/Promo/PromoHelp";
import PromoReviews from "@/components/Promo/PromoReviews";
import { PromoScreen } from "@/components/Promo/PromoScreen";
import PromoZingAi from "@/components/Promo/PromoZingAI";
import ReviewAndActiveUsers from "@/components/Promo/ReviewAndActiveUsers";
import ReviewWithLoader from "@/components/Promo/ReviewWithLoader";
import Checkbox from "@/components/Questions/Checkbox";
import CheckboxImageLeft from "@/components/Questions/CheckboxImageLeft";
import CheckboxInline from "@/components/Questions/CheckboxInline";
import CurrencyInput from "@/components/Questions/CurrencyInput";
import DateQuestion from "@/components/Questions/Date";
import DecimalInput from "@/components/Questions/DecimalInput";
import Radio from "@/components/Questions/Radio";
import RadioImageLeft from "@/components/Questions/RadioImageLeft";
import Range from "@/components/Questions/Range";
import RangeNumber from "@/components/Questions/RangeNumber";
import Rate from "@/components/Questions/Rate";
import { YesNo } from "@/components/Questions/YesNo";
import YesNoWithImage from "@/components/Questions/YesNoWithImage";
import { QuestionTypes } from "@/constants/questionsIds";
import PromoSocialProof from "@/female/components/PromoSocialProof";

export const COMPONENTS_BY_QUESTION_TYPE: Record<QuestionTypes | string, ComponentType<any>> = {
    [QuestionTypes.CheckboxImageLeft]: CheckboxImageLeft,
    [QuestionTypes.Checkbox]: Checkbox,
    [QuestionTypes.CheckboxInline]: CheckboxInline,
    [QuestionTypes.Input]: DecimalInput,
    [QuestionTypes.Radio]: Radio,
    [QuestionTypes.RadioImageLeft]: RadioImageLeft,
    [QuestionTypes.ReviewsPromo]: PromoReviews,
    [QuestionTypes.BmiPromoMale]: BmiScreenMale,
    [QuestionTypes.BmiPromoFemale]: BmiScreenFemale,
    [QuestionTypes.Date]: DateQuestion,
    [QuestionTypes.PromoHelp]: PromoHelp,
    [QuestionTypes.Rate]: Rate,
    [QuestionTypes.Cortisol]: CortisolScreen,
    [QuestionTypes.CalisthenicsFeedbackLoops]: CalisthenicsFeedbackLoops,
    [QuestionTypes.Range]: Range,
    [QuestionTypes.RangeNumber]: RangeNumber,
    [QuestionTypes.PromoCyclePhase]: CyclePhase,
    [QuestionTypes.AIBodyScan]: AIBodyScanPromo,
    [QuestionTypes.YesNo]: YesNo,
    [QuestionTypes.YesNoWithImage]: YesNoWithImage,
    [QuestionTypes.PromoScreen]: PromoScreen,
    [QuestionTypes.PromoZingAi]: PromoZingAi,
    [QuestionTypes.PromoSocialProof]: PromoSocialProof,
    [QuestionTypes.InitialWeightPredict]: InitialWeightPredictScreen,
    [QuestionTypes.CurrencyInput]: CurrencyInput,
    [QuestionTypes.ReviewWithLoader]: ReviewWithLoader,
    [QuestionTypes.ReviewAndActiveUsers]: ReviewAndActiveUsers,
};
